import { render, staticRenderFns } from "./EditAmountPopup.vue?vue&type=template&id=4c014a7d&scoped=true"
import script from "./EditAmountPopup.vue?vue&type=script&lang=js"
export * from "./EditAmountPopup.vue?vue&type=script&lang=js"
import style0 from "./EditAmountPopup.vue?vue&type=style&index=0&id=4c014a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c014a7d",
  null
  
)

export default component.exports